import * as React from "react";
import { gql, useMutation, ApolloError, MutationTuple } from "@apollo/client";

import {
  UpdateAdminMutationMutation,
  UpdateAdminMutationMutationVariables
} from "../../../schemaTypes";

export const updateAdminMutation = gql`
  mutation UpdateAdminMutation($input: UpdateAdminInput!) {
    updateAdmin(input: $input) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export const UpdateAdmin: React.FC<{ children: (data: {
  updateAdmin: MutationTuple<UpdateAdminMutationMutation, UpdateAdminMutationMutationVariables>[0];
  loading: boolean;
  error?: ApolloError;
  data?: UpdateAdminMutationMutation;
  errors?: { path: string; message: string }[] | null;
  message?: string | null;
}) => React.ReactElement | null }> = ({ children }) => {
  const [updateAdmin, { loading, error, data }] = useMutation<UpdateAdminMutationMutation, UpdateAdminMutationMutationVariables>(updateAdminMutation);

  // Extract errors and message from the mutation result, matching resolver response
  const errorsRaw = data?.updateAdmin?.errors ?? null;
  const errors = Array.isArray(errorsRaw)
    ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
    : errorsRaw;
  const message = data?.updateAdmin?.message ?? null;

  return children({
    updateAdmin,
    loading,
    error,
    data: data ?? undefined,
    errors,
    message
  });
};
